import { render, staticRenderFns } from "./CrmUserBranches.vue?vue&type=template&id=0e885d7c&scoped=true&"
import script from "./CrmUserBranches.vue?vue&type=script&lang=js&"
export * from "./CrmUserBranches.vue?vue&type=script&lang=js&"
import style0 from "./CrmUserBranches.vue?vue&type=style&index=0&id=0e885d7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e885d7c",
  null
  
)

export default component.exports